import lodash from 'lodash'
import { hash } from 'ohash'
import RootSrore from '~/store/create'
import singleToken, { TokenFields, TokenKey, TokenType } from '@xt/client/experimental/request/token'
import singleServiceTime from '@xt/client/experimental/server-time'
import { reportEntryLog } from '@xt/client/utils/log'
const { $global } = RootSrore

const UserStorageKey = `${$global.localStorageStartsWith}User`
const userStorage = localStorage.getItem(UserStorageKey)
const tokenStorage = localStorage.getItem(TokenKey)

// 同步登录状态  兼容老版本
if (userStorage && !tokenStorage) {
  try {
    const parseUser = JSON.parse(userStorage)
    if (parseUser.UserInfo.access_token) {
      console.warn('即将执行同步Token逻辑')
      const pickTokenFields = lodash.pick(parseUser.UserInfo, TokenFields)
      singleToken.setToken(pickTokenFields as TokenType)
      // 不需要变更用户信息的Storage，因为在后续调用myself后，持久化仓库中的UserInfo会被覆盖成最新的（纯用户信息数据）
      reportEntryLog('debug.syncLogin.success', {
        clientTime: Date.now(),
        serverTime: singleServiceTime.serviceDate.utcOffset(+8).valueOf(),
        access_hash: hash(pickTokenFields.access_token),
        refresh_hash: hash(pickTokenFields.refresh_token)
      })
    }
  } catch (error) {
    reportEntryLog('debug.syncLogin.error', {
      clientTime: Date.now(),
      serverTime: singleServiceTime.serviceDate.utcOffset(+8).valueOf(),
      errorMsg: error
    })
  }
}
